if (!customElements.get("m-slideshow")) {
  class MSlideshow extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.autoplay = this.dataset.autoplay === "true";
      this.autoplaySpeed = parseInt(this.dataset.autoplaySpeed || "0", 10);
      this.showArrows = this.dataset.enableArrows === "true";
      this.showDots = this.dataset.enableDots === "true";
      this.adaptHeight = this.dataset.slideHeight === "adapt";
      this.id = this.dataset.id;
      this.sliderContainer = this.querySelector(".swiper-container");

      this.lastVideo = null;
      this.lastActive = null;
      this.timeout = null;

      this.initSlider();
    }

    initSlider() {
      if (!this.sliderContainer) return;
      if (!window.MinimogLibs || !window.MinimogLibs.Swiper) return;

      this.slider = new MinimogLibs.Swiper(this.sliderContainer, {
        init: false,
        autoplay: this.autoplay && this.autoplaySpeed > 0
          ? {
              delay: this.autoplaySpeed * 1000,
              disableOnInteraction: true,
            }
          : false,
        slidesPerView: 1,
        slidesPerGroup: 1,
        loop: true,
        effect: "fade",
        fadeEffect: {
          crossFade: true,
        },
        speed: 1000,
        navigation: this.showArrows
          ? {
              nextEl: this.querySelector(".m-slider-controls__button-next"),
              prevEl: this.querySelector(".m-slider-controls__button-prev"),
            }
          : false,
        pagination: this.showDots
          ? {
              el: this.querySelector(".swiper-pagination"),
              clickable: true,
              bulletClass: "m-dot",
              bulletActiveClass: "m-dot--active",
            }
          : false,
        breakpoints: {
          992: {
            threshold: 2,
          },
        },
        on: {
          init() {
            setTimeout(() => {
              window.dispatchEvent(new Event("resize"));
            }, 100);
          },
        },
      });

      this.slider && this.slider.on("init", this.handleChange.bind(this));
      this.slider && this.slider.on("slideChange", this.handleChange.bind(this));
      this.slider.init();

      if (window.Shopify && Shopify.designMode) {
        document.addEventListener("shopify:block:select", (e) => this.onBlockSelect(e));
      }
    }

    handleChange(swiper) {
      const { activeIndex, slides } = swiper;
      const slideType = slides[activeIndex] && slides[activeIndex].dataset.slideType;

      if (this.lastActive !== null && this.lastActive !== undefined) {
        this.slider.slideToLoop(this.lastActive);
        this.lastActive = null;
      }

      if (slideType === "video_slide") {
        const video = slides[activeIndex] && slides[activeIndex].querySelector("video");

        if (video) {
          let playPromise = video.play();
          this.lastVideo && this.lastVideo.pause();
          if (playPromise !== undefined) {
            playPromise.then(() => {
              this.lastVideo = video;
            }).catch(() => {});
          }
        }
      } else {
        this.lastVideo && this.lastVideo.pause();
        this.lastVideo = null;
      }
    }

    onBlockSelect(ev) {
      const block = ev.target;
      const index = Number(block.dataset.slide);
      this.lastActive = index;

      if (this.slider) {
        this.slider.slideToLoop(index);
      }
    }
  }

  customElements.define("m-slideshow", MSlideshow);
}

(function () {
  const body = document.body;

  function ensureModal() {
    let modal = document.querySelector(".m-video-modal");
    if (modal) return modal;

    modal = document.createElement("div");
    modal.className = "m-video-modal";
    modal.innerHTML = `
      <div class="m-video-modal__overlay" data-close-video-modal="true"></div>
      <div class="m-video-modal__content" role="dialog" aria-modal="true">
        <button class="m-video-modal__close" type="button" aria-label="Fechar" data-close-video-modal="true">✕</button>
        <video class="m-video-modal__video" controls playsinline preload="metadata"></video>
      </div>
    `;
    document.body.appendChild(modal);
    return modal;
  }

  function openModal(videoSrc) {
    const modal = ensureModal();
    const video = modal.querySelector("video");
    if (!video) return;

    video.pause();
    video.removeAttribute("src");
    video.load();

    video.src = videoSrc;

    modal.classList.add("is-open");
    body.classList.add("m-video-modal-open");
  }

  function closeModal() {
    const modal = document.querySelector(".m-video-modal");
    if (!modal) return;

    const video = modal.querySelector("video");

    modal.classList.remove("is-open");
    body.classList.remove("m-video-modal-open");

    if (video) {
      video.pause();
      video.currentTime = 0;
      video.removeAttribute("src");
      video.load();
    }
  }

  document.addEventListener("click", function (e) {
    const openBtn = e.target.closest('[data-open-video-modal="true"]');
    if (openBtn) {
      const src = openBtn.getAttribute("data-video-src");
      if (src) openModal(src);
      return;
    }

    const closeBtn = e.target.closest('[data-close-video-modal="true"]');
    if (closeBtn) closeModal();
  });

  document.addEventListener("keydown", function (e) {
    if (e.key === "Escape") closeModal();
  });
})();